import React, { useEffect, useMemo, useState } from "react";
import VelkieLayout from "./VelkieLayout";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { isEmpty } from "lodash";
import { formatWithCommas } from "../../Utils/Toast";
import moment from "moment";
import { useNavigate } from "react-router-dom";
const LeagueVelki = () => {
  const [list, setList] = useState([]);
  const [active, setActive] = useState({});
  const [tab, setTab] = useState("cricket");
  const navigate = useNavigate();
  const stableTab = useMemo(() => tab, [tab]);
  const leagueData = async () => {
    const { status, data } = await apiGet(apiPath.seriesList, {
      gameType: stableTab,
    });
    if (data?.success) {
      setList(data?.results);
    }
  };
  useEffect(() => {
    leagueData();
  }, [stableTab]);
  const sports = [
    { key: "cricket", label: "Cricket", icon: "icon-cricket", active: true },
    { key: "soccer", label: "Soccer", icon: "icon-soccer", active: false },
    { key: "tennis", label: "Tennis", icon: "icon-tennis", active: false },
  ];
  function isDateToday(date) {
    return moment(date).isSame(moment(), "day");
  }
  return (
    <VelkieLayout visibilityType={true}>
      {isEmpty(active) ? (
        <div data-v-fa12c4fa className="relative">
          <section data-v-b0f49a45>
            <section
              data-v-b0f49a45
              className="py-2 bg-submenu flex overflow-x-scroll"
            >
              <ul
                data-v-b0f49a45
                className="sport-type-filter-ul space-x-2 ml-8px flex flex-nowrap overflow-x-scroll"
              >
                {sports.map((sport, index) => (
                  <li
                    style={{ borderRadius: "15px" }}
                    onClick={() => setTab(sport?.key)}
                    key={index}
                    data-v-b0f49a45
                    className={`h-30px w-80px justify-center flex items-center text-13 font-bold whitespace-nowrap event-type-tab ${
                      tab == sport?.key
                        ? "text-filter-active-icon bg-filter-active active"
                        : "text-global-font-on-dark"
                    }`}
                  >
                    <i
                      data-v-b0f49a45
                      className={`mr-1 text-17 ${sport.icon}`}
                    />
                    <span data-v-b0f49a45 className="mt">
                      {sport.label}
                    </span>
                  </li>
                ))}
              </ul>
            </section>
            <div data-v-b0f49a45 className="flex px-4 pb-20">
              <div data-v-b0f49a45 className="flex-1">
                <div data-v-b0f49a45>
                  <div data-v-b0f49a45>
                    <div
                      data-v-b0f49a45
                      className="opacity-0 h-0 text-15 leading-20px font-bold"
                    >
                      My Top Leagues
                    </div>
                    <div
                      data-v-b0f49a45
                      className="mt-6px mb-8px text-category-title text-15 leading-20px font-bold"
                    >
                      Popular
                    </div>

                    {list?.map((res) => {
                      return (
                        <div
                          onClick={() => setActive(res)}
                          data-v-b0f49a45
                          className="flex pr-8px justify-between items-center bg-white text-15 mb-1px rounded-t-lg"
                        >
                          <span className="icon-top text-16 mr-8px pl-13px py-16px" />
                          <span className="flex-1 break-all py-2 mr-2 leading-120%">
                            {res?.seriesName}
                          </span>
                          <span className="icon-arrow-left transform rotate-180 text-12 text-black-500" />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      ) : (
        <div data-v-fa12c4fa className="relative">
          <div className>
            <section>
              <div className="px-4 bg-black text-white text-button-normal text-14 flex items-center justify-center shadow-sm">
                <div
                  onClick={() => setActive({})}
                  className="icon-arrow-left mr-4 text-14"
                />
                <div className="flex-1 py-12px leading-20px">
                  Caribbean Premier League
                </div>
              </div>
            </section>
            <section className="px-4 my-4 mt-4 mb-20 text-global-font-default-light">
              <div>
                <div className="bg-white rounded-lg text-15px divide-y divide-black-300 shadow-sm">
                  {active?.matchList?.map((res) => {
                    return (
                      <div>
                        <div
                          onClick={() =>
                            navigate(
                              `/match-detail-velki/${res?.eventId}/${res?.marketId}`
                            )
                          }
                          data-v-2b1875c6
                          className="min-h-45px flex justify-between item-center gap-2 py-2 pl-4 pr-2"
                        >
                          <div
                            data-v-2b1875c6
                            className="flex flex-col justify-center flex-1"
                          >
                            <div
                              data-v-2b1875c6
                              className="flex flex-1 items-center"
                            >
                              {res?.status == "in_play" ? (
                                <div
                                  data-v-ef8204d4
                                  className="inline-flex items-center h-full mr-3px"
                                  data-is-inplay-type="true"
                                  data-is-today-type="false"
                                  data-is-tomorrow-type="false"
                                >
                                  <div data-v-ef8204d4 className>
                                    <div
                                      data-v-ef8204d4
                                      className="px-3px flex items-center justify-center bg-inPlay text-white font-bold text-8 leading-9px"
                                    >
                                      <span data-v-ef8204d4 className="mt-1px">
                                        In-Play
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div
                                  data-v-ef8204d4
                                  className="time-block flex items-center justify-center leading-9px"
                                  data-is-today-type="true"
                                  data-is-tomorrow-type="false"
                                >
                                  <span
                                    data-v-ef8204d4
                                    className="text-submenu py-px text-center text-8 px-2px pb-0"
                                  >
                                    {isDateToday(res?.eventDateTime)
                                      ? "Today"
                                      : moment(res?.eventDateTime).format(
                                          "DD/MM"
                                        )}{" "}
                                    {moment(res?.eventDateTime).format("HH:MM")}
                                  </span>
                                </div>
                              )}

                              <div
                                data-v-2b1875c6
                                className="text-10 text-black-600 font-normal"
                              >
                                <span data-v-2b1875c6 className="pr-1">
                                  Matched
                                </span>
                                <span data-v-2b1875c6>
                                  {formatWithCommas(res?.totalMatched)}
                                </span>
                              </div>
                            </div>
                            <div data-v-2b1875c6 className="mt-1px">
                              <div
                                data-v-2b1875c6
                                className="text-13 leading-17px break-words"
                              >
                                <span data-v-2b1875c6>{res?.eventName}</span>
                              </div>
                            </div>
                          </div>
                          <div
                            data-v-2b1875c6
                            className="flex justify-end items-center"
                          >
                            <div data-v-2b1875c6>
                              <i
                                data-v-2b1875c6
                                className="block icon-arrow-left self-center text-12 text-black-400 rotate-180"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </section>
          </div>
        </div>
      )}
    </VelkieLayout>
  );
};

export default LeagueVelki;
